import React, { useEffect } from 'react';
import { OTPVerificationForm } from '../../../shared/otpVerificationForm/OTPVerificationForm';
import { useMfaInitMutation, useMfaVerifyMutation } from '../../../slices/account-api.slice';
import { useSelector } from 'react-redux';
import { selectFirstEmailContact } from '../../../slices/login.slice';

interface LoginOTPVerifyProps {
    onNext?: () => void;
}

export function LoginOTPVerify({ onNext }: LoginOTPVerifyProps) {
    const otpContact = useSelector(selectFirstEmailContact);
    const [mfaInit, mfaInitMutation] = useMfaInitMutation();
    const [mfaVerify, mfaVerifyMutation] = useMfaVerifyMutation();

    useEffect(() => {
        if (mfaVerifyMutation.isSuccess && onNext) {
            onNext();
        }
    }, [mfaVerifyMutation.isSuccess, onNext]);

    function onResend() {
        if (otpContact) {
            mfaInit(otpContact);
        }
    }

    function onSubmit({ passcode }) {
        if (otpContact) {
            mfaVerify({
                ...otpContact,
                passcode
            });
        }
    }

    return (
        <OTPVerificationForm
            otpContact={otpContact}
            onResend={onResend}
            onSubmit={onSubmit}
            disabled={mfaVerifyMutation.isLoading || mfaInitMutation.isLoading}
            mutation={mfaVerifyMutation}
        />
    );
}
